import React, { useState, useEffect } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';

// Timing constants for better maintainability
const BUTTON_DISPLAY_DELAY = 1000; // Show buttons after 1 second
const TEXT_AUTO_HIDE_DELAY = 8000; // Hide text after 8 seconds

export const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showText, setShowText] = useState(true);
  const phoneNumber = '573226882325'; // Formato internacional para Colombia
  const phoneCall = '+573226882325'; // Para llamadas

  useEffect(() => {
    // Mostrar los botones después de 1 segundo
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, BUTTON_DISPLAY_DELAY);

    // Ocultar el texto después de 8 segundos
    const textTimer = setTimeout(() => {
      setShowText(false);
    }, TEXT_AUTO_HIDE_DELAY);

    return () => {
      clearTimeout(timer);
      clearTimeout(textTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // Note: setIsVisible and setShowText are stable by React design
    // BUTTON_DISPLAY_DELAY and TEXT_AUTO_HIDE_DELAY are constants that never change
    // This effect should only run once on mount
  }, []);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, necesito información sobre sus servicios técnicos.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = `tel:${phoneCall}`;
  };

  const toggleText = () => {
    setShowText(!showText);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Texto "HABLA YA CON UN ASESOR" */}
      {showText && (
        <div className="hidden md:flex items-center gap-2 bg-white shadow-2xl rounded-full px-6 py-3 border-2 border-green-500 animate-bounce">
          <span className="font-bold text-gray-800 text-sm whitespace-nowrap">
            HABLA YA CON UN ASESOR
          </span>
          <button
            onClick={toggleText}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}

      {/* Botón de WhatsApp */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setShowText(true)}
        className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110"
        aria-label="Contactar por WhatsApp"
      >
        <MessageCircle className="w-8 h-8" />
        
        {/* Pulso animado */}
        <span className="absolute inset-0 rounded-full bg-green-500 opacity-75 animate-ping"></span>
        
        {/* Tooltip en mobile */}
        <div className="md:hidden absolute bottom-full right-0 mb-2 bg-white text-gray-800 px-4 py-2 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap text-xs font-bold border-2 border-green-500">
          WhatsApp
          <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-green-500"></div>
        </div>
      </button>

      {/* Botón de Llamadas */}
      <button
        onClick={handleCallClick}
        className="group relative bg-blue-600 hover:bg-blue-700 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl hover:shadow-blue-600/50 transition-all duration-300 hover:scale-110"
        aria-label="Llamar ahora"
      >
        <Phone className="w-8 h-8" />
        
        {/* Tooltip en mobile */}
        <div className="md:hidden absolute bottom-full right-0 mb-2 bg-white text-gray-800 px-4 py-2 rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap text-xs font-bold border-2 border-blue-600">
          Llamar
          <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-blue-600"></div>
        </div>
      </button>
    </div>
  );
};
